export default __webpack_public_path__ + "static/media/10_4_0.ef588a1c.png";